import React from 'react';
import { COLORS } from '../utils/constants.js';
import Spinner from '../components/Spinner.jsx';

export default function AITools({ selectedContact, ai }) {
  const { aiOutput, aiLoading, scoreLead, draftEmail, analyzeCompany } = ai;

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}><span style={{ color: COLORS.purple }}>✦</span> AI-Powered Tools</h2>
      <p style={{ color: COLORS.textMuted, fontSize: 13, marginBottom: 20 }}>Claude AI for lead scoring, email drafting, and analysis</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16, marginBottom: 20 }}>
        {/* Lead Scorer */}
        <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>🎯</span>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>Lead Scorer</h3>
          </div>
          <p style={{ fontSize: 13, color: COLORS.textMuted, margin: '0 0 14px' }}>AI-powered scoring from A to F based on title, seniority, and company fit.</p>
          {selectedContact ? (
            <div>
              <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 12px', color: COLORS.accent }}>{selectedContact.first_name} {selectedContact.last_name} — {selectedContact.title || 'Unknown'}</p>
              <button onClick={() => scoreLead(selectedContact)} disabled={aiLoading} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.purple}, ${COLORS.blueDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: aiLoading ? 'wait' : 'pointer', opacity: aiLoading ? 0.7 : 1, fontFamily: 'inherit' }}>
                {aiLoading ? 'Scoring...' : 'Score This Lead'}
              </button>
            </div>
          ) : <p style={{ fontSize: 12, color: COLORS.textDim, fontStyle: 'italic' }}>Select a contact from the Contacts tab.</p>}
        </div>

        {/* Email Drafter */}
        <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>✉️</span>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>Email Drafter</h3>
          </div>
          <p style={{ fontSize: 13, color: COLORS.textMuted, margin: '0 0 14px' }}>Personalized cold outreach emails with subject lines and CTAs.</p>
          {selectedContact ? (
            <div>
              <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 12px', color: COLORS.accent }}>{selectedContact.first_name} {selectedContact.last_name}</p>
              <button onClick={() => draftEmail(selectedContact, 'cold outreach')} disabled={aiLoading} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentDim})`, color: COLORS.bg, fontSize: 13, fontWeight: 600, cursor: aiLoading ? 'wait' : 'pointer', opacity: aiLoading ? 0.7 : 1, fontFamily: 'inherit' }}>
                {aiLoading ? 'Drafting...' : 'Draft Outreach Email'}
              </button>
            </div>
          ) : <p style={{ fontSize: 12, color: COLORS.textDim, fontStyle: 'italic' }}>Select a contact first.</p>}
        </div>

        {/* Company Analyzer */}
        <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>🏢</span>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>Company Analyzer</h3>
          </div>
          <p style={{ fontSize: 13, color: COLORS.textMuted, margin: '0 0 14px' }}>Fit analysis, pain points, and approach strategy.</p>
          <button onClick={() => analyzeCompany({ name: 'Example Corp', domain: 'example.com', industry: 'Technology' })} disabled={aiLoading} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.green}, ${COLORS.greenDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: aiLoading ? 'wait' : 'pointer', opacity: aiLoading ? 0.7 : 1, fontFamily: 'inherit' }}>
            {aiLoading ? 'Analyzing...' : 'Analyze Company'}
          </button>
        </div>
      </div>

      {/* AI Output */}
      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${aiOutput ? COLORS.accent : COLORS.border}` }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}><span style={{ color: COLORS.purple }}>✦</span> AI Output</h3>
          {aiLoading && <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: COLORS.accent, fontSize: 12 }}><Spinner size={14} /> Processing...</div>}
        </div>
        <pre style={{ margin: 0, padding: 16, borderRadius: 8, background: COLORS.bg, border: `1px solid ${COLORS.border}`, fontSize: 12, color: COLORS.textMuted, fontFamily: "'Space Mono', monospace", whiteSpace: 'pre-wrap', wordBreak: 'break-word', minHeight: 120, maxHeight: 400, overflowY: 'auto' }}>
          {aiOutput || (aiLoading ? '⏳ Waiting for Claude AI...' : 'AI output will appear here.')}
        </pre>
      </div>
    </div>
  );
}
